/* GLOWZ Redesign interactions — Cowork. Vanilla JS. */
(function(){
  function baInit(root){
    var range=root.querySelector('.glowz-ba__range');
    if(!range||range.dataset.init)return; range.dataset.init='1';
    var after=root.querySelector('.glowz-ba__after');
    var line=root.querySelector('.glowz-ba__line');
    var handle=root.querySelector('.glowz-ba__handle');
    function set(v){ after.style.clipPath='inset(0 0 0 '+v+'%)'; line.style.left=v+'%'; handle.style.left=v+'%'; }
    range.addEventListener('input',function(){set(this.value);});
    set(range.value||50);
  }
  function transInit(root){
    if(root.dataset.init)return; root.dataset.init='1';
    var tabs=root.querySelectorAll('.glowz-trans__tab');
    var panels=root.querySelectorAll('.glowz-trans__panel');
    tabs.forEach(function(tab,i){
      tab.addEventListener('click',function(){
        tabs.forEach(function(t){t.setAttribute('aria-selected','false');});
        panels.forEach(function(p){p.classList.remove('is-active');});
        tab.setAttribute('aria-selected','true');
        if(panels[i])panels[i].classList.add('is-active');
      });
    });
  }
  function faqInit(root){
    if(root.dataset.init)return; root.dataset.init='1';
    root.querySelectorAll('.glowz-faq__q').forEach(function(q){
      q.addEventListener('click',function(){
        var item=q.closest('.glowz-faq__item');
        var ans=item.querySelector('.glowz-faq__a');
        var open=item.classList.toggle('is-open');
        ans.style.maxHeight=open?(ans.scrollHeight+40)+'px':'0px';
      });
    });
  }
  function galleryInit(root){
    if(root.dataset.init)return; root.dataset.init='1';
    var main=root.querySelector('.glowz-gallery__main img');
    root.querySelectorAll('.glowz-gallery__thumb').forEach(function(t){
      t.addEventListener('click',function(){
        root.querySelectorAll('.glowz-gallery__thumb').forEach(function(x){x.classList.remove('is-active');});
        t.classList.add('is-active');
        var src=t.getAttribute('data-full'); if(src&&main)main.src=src;
      });
    });
  }
  function money(cents){
    try{return new Intl.NumberFormat('de-DE',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}).format(cents/100);}catch(e){return (cents/100).toFixed(2)+' €';}
  }
  function swInit(root){
    if(root.dataset.init)return; root.dataset.init='1';
    var state={mode:'sub'};
    var opts=root.querySelectorAll('.glowz-sw__opt');
    var variants=root.querySelectorAll('.glowz-sw__variant');
    var subDiscount=parseFloat(root.dataset.subDiscount||'20')/100;
    var totalEl=root.querySelector('.glowz-sw__total .t');
    var saveEl=root.querySelector('.glowz-sw__save-line');
    var btnPrice=root.querySelector('.glowz-sw__add-price');
    var btnOld=root.querySelector('.glowz-sw__add-old');
    function activeVariant(){return root.querySelector('.glowz-sw__variant.is-active')||variants[0];}
    function render(){
      var v=activeVariant(); if(!v)return;
      var base=parseInt(v.dataset.price,10);
      var price=state.mode==='sub'?Math.round(base*(1-subDiscount)):base;
      if(totalEl)totalEl.textContent=money(price);
      if(btnPrice)btnPrice.textContent=money(price);
      if(btnOld){ if(price<base){btnOld.textContent=money(base);btnOld.style.display='';} else {btnOld.style.display='none';} }
      var pf=root.querySelector('[data-pay-variant]');
      if(pf){pf.value=v.dataset.variantId;try{pf.dispatchEvent(new Event('change',{bubbles:true}));}catch(e){}}
      if(saveEl){
        if(state.mode==='sub'){saveEl.style.display='';saveEl.textContent='Du sparst '+money(base-price)+' pro Lieferung';}
        else{saveEl.style.display='none';}
      }
    }
    opts.forEach(function(o){
      o.addEventListener('click',function(){
        opts.forEach(function(x){x.classList.remove('is-active');});
        o.classList.add('is-active'); state.mode=o.dataset.mode; render();
      });
    });
    variants.forEach(function(v){
      v.addEventListener('click',function(){
        variants.forEach(function(x){x.classList.remove('is-active');});
        v.classList.add('is-active'); render();
      });
    });
    var btn=root.querySelector('.glowz-sw__add');
    if(btn){
      btn.addEventListener('click',function(){
        var v=activeVariant(); if(!v)return;
        var id=v.dataset.variantId;
        var props={};
        var planLabel=state.mode==='sub'?('Abo – '+(root.dataset.subDiscount||'20')+'% Rabatt'):'Einmaliger Kauf';
        props['Kaufoption']=planLabel;
        if(state.mode==='sub'){
          var freq=root.querySelector('.glowz-sw__opt.is-active .glowz-sw__freq select');
          props['Lieferintervall']=freq?freq.value:'Alle 30 Tage';
          var gift=root.dataset.gift; if(gift)props['Gratis-Zugabe']=gift;
        }
        var orig=btn.innerHTML; btn.disabled=true; btn.innerHTML='Wird hinzugefügt…';
        fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:parseInt(id,10),quantity:1,properties:props}]})})
          .then(function(r){return r.json();})
          .then(function(){ btn.disabled=false; btn.innerHTML=orig; if(window.GXCart){window.GXCart.open();} else {window.location.href='/cart';} })
          .catch(function(){btn.disabled=false;btn.innerHTML=orig;window.location.href='/cart';});
      });
    }
    render();
  }
  function revealInit(scope){
    var els=(scope||document).querySelectorAll('.glowz-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in');});return;}
    var io=new IntersectionObserver(function(ents){
      ents.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}});
    },{threshold:.12});
    els.forEach(function(e){io.observe(e);});
  }
  function initAll(scope){
    scope=scope||document;
    scope.querySelectorAll('.glowz-ba').forEach(baInit);
    scope.querySelectorAll('.glowz-trans').forEach(transInit);
    scope.querySelectorAll('.glowz-faq').forEach(faqInit);
    scope.querySelectorAll('.glowz-gallery').forEach(galleryInit);
    scope.querySelectorAll('.glowz-sw').forEach(swInit);
    revealInit(scope);
  }
  if(document.readyState!=='loading')initAll();
  else document.addEventListener('DOMContentLoaded',function(){initAll();});
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();